import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { observer } from 'mobx-react';
import { ComponentJSSClasses } from './styles';
import { getHotelReviewSourceLogo, formatDate, getTripTypeLabel } from '../../../../utils/reviews';
import { HotelReview as HotelReviewProps } from '../../../../models/hotel-reviews';
import { DEFAULT_REPORTER_NAME } from '../../../../consts/reviews';
import { ReviewText } from './ReviewText';
import { CompanyAnswer } from './CompanyAnswer';
import { Avatar } from './Avatar';
import { ReviewHeader } from './ReviewHeader';
import { ReviewGallery } from './ReviewGallery';
import S from '../../../../stores';
import classNames from 'classnames';

export interface ReviewCardProps {
    review: HotelReviewProps;
}

interface StyledReviewCardProps extends JSSClassesProps<ComponentJSSClasses>, ReviewCardProps {}

export const ReviewCard = observer((props: StyledReviewCardProps) => {
    const { classes, review } = props;
    const isTablet = S.hotelReviews.isTabletL;
    const isMobile = S.hotelReviews.isMobile;

    const tagsBlock = () => (
        <>
            {review.tripType && <p className={classes.tag}>{getTripTypeLabel(review.tripType)}</p>}
            {review.roomType && <p className={classes.tag}>{review.roomType}</p>}
        </>
    );

    const reporterBlock = () => (
        <div className={classes.reporter}>
            <Avatar
                avatar={review.userAvatar ?? null}
                reporterName={review.reporterName ?? DEFAULT_REPORTER_NAME}
            />
            <span className={classes.reporterName}>
                {review.reporterName ?? DEFAULT_REPORTER_NAME}
            </span>
        </div>
    );

    const sourceBlock = () => (
        <>
            <div
                className={classes.sourceLogo}
                style={{ backgroundImage: `url(${getHotelReviewSourceLogo(review.sourceKind)})`}}
            />
            <p className={classes.reviewCreated}>
                Дата отзыва: {formatDate(review.creationDate)}
            </p>
         </>
    );

    const visitDateBlock = () => (
        <p className={classes.tripDate}>
            Дата путешествия: {formatDate(review.visitDate)}
        </p>
    );


    return (
        <article className={classes.container}>
            <div
                className={classNames(classes.content, {
                  [classes.withManagementResponse]: review.managementResponse
                })}
            >
                <div className={classes.leftContent}>
                    <ReviewHeader
                        rating={review.rating}
                        title={review.title}
                        additionalRating={review.additionalRatings}
                    />
                    {(isTablet || isMobile) && (
                        <div className={classes.infoBlockTablet}>
                            <div className={classes.tagWrapper}>
                                {reporterBlock()}
                                {review.visitDate && visitDateBlock()}
                            </div>
                            <div>{tagsBlock()}</div>
                            {!isMobile && <div>{sourceBlock()}</div>}
                        </div>
                    )}
                    <ReviewText
                        negativeFeedback={review.negativeFeedback ?? ''}
                        positiveFeedback={review.positiveFeedback ?? ''}
                        positiveHits={review.positiveHits}
                        negativeHits={review.negativeHits}
                        activeFilterHits={[...S.hotelReviews.interestsFilter]}
                    />
                    {review.photos?.length ? (
                        <ReviewGallery
                            photos={review.photos}
                            isMobile={S.hotelReviews.isMobile}
                        />
                    ) : null}

                    {isMobile && (
                        <div className={classes.sourceLogoReviewCreatedWrap}>
                            {sourceBlock()}
                        </div>
                    )}
                </div>
                <div className={classes.rightContent}>
                    <div className={classes.shortTourInfo}>
                        {reporterBlock()}
                        {tagsBlock()}
                        {review.visitDate && visitDateBlock()}
                    </div>
                    <div>{sourceBlock()}</div>
                </div>
            </div>
            {review.managementResponse ? (
                <CompanyAnswer
                    answer={review?.managementResponse}
                    hotelName={S.hotelDetails.hotelName ?? ''}
                    creationDate={review?.managementResponseDate ?? ''}
                />
            ) : null}
        </article>
    );
});
